import en from "./en";
import ru from "./ru";

const languages = {
    en,
    ru,
};

export default languages;